<script>
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap

import { useToast } from "vue-toastification";

import LoadingScreen from '@/components/General/LoadingScreen'
import Alert from '@/components/General/Alert'

//components
import MyPagination from '@/components/SystemElements/PaginationV2.vue'
import MyCountRecords from '@/components/SystemElements/CountRecordsOptionsV2.vue'

//general functions
import MixinGeneralFunct from '@/mixins/GeneralFunctions';
import { defineComponent } from 'vue'

import AuditLog from '@/components/Core/AuditLog/AuditLog.vue'


//data
import { getAuditLogs } from '@/services/serviceAuditLogs';

export default defineComponent ({
	setup() {
		const toast = useToast();
		return { toast }
	},
	name: 'AuditLogs',
	mixins: [ MixinGeneralFunct ],
	components: {
		LoadingScreen
		,MyPagination
		,MyCountRecords
		,Alert
		,AuditLog
	},
	props: {'currentDoc':Object, 'typeId': String, 'docId': String, 'auth':Object, 'secData':Object},
	emits: ["changeRecord"],
	data() {
		return {
			prefix:'',
		
			metaData: [],
			
			menuItems: [],
			isLoading:false,
			
			selectedPage:1,
			selectedRecords:10,
			selectedCol:'a.id',
			selectedSort:'desc',
											
			filterExtended:false,
			showFilter:false,
			
			totalCount:0,
			dataList:[],

			docToView:{},
			
			selectedDate:'',
			selectedDocId:'',
			selectedTypeId:'',

			logList:[],
			logMetaData:{},
			logTotalCount:0,
			logSelectedPage:1,
			logSelectedRecords:10,
			logSelectedCol:'a.id',
			logSelectedSort:'desc',
			logSelectedFilterText:'',

			//modals
			modalAuditLogs:{},
			modalAuditLogId:'',
		}
	},
	
	mounted:function(){
		this.modalAuditLogId = `modaluser${this.getRandomInt(999999999)}`;
		if(this.docId){
			this.onLoadPage();
		}
	},
	
	methods: {
		// load data form
		onLoadPage:function(){
			
			this.isLoading=true

			getAuditLogs({filterText: this.logSelectedFilterText, orderCol: this.logSelectedCol, orderSort: this.logSelectedSort, page: this.logSelectedPage, records: this.logSelectedRecords, docId:this.docId,typeId:this.typeId}).then(response => {
				if(!response.statusText){
					this.isLoading=false
					this.logList = response.results;
					this.logMetaData = response.metaData;
					this.logTotalCount = response.totalCount;

				}else{
					this.isLoading=false
					this.errorStatus=`${response.statusText} ${response.status}`
				}
			});


			
		},

		//modal box audit logs
		loadModalAuditLogDetail:function(date,docId,typeId){
			this.cSession();
			this.selectedDate=date;
			this.selectedDocId=docId;
			this.selectedTypeId=typeId;
			this.modalAuditLogs = new bootstrap.Modal(document.getElementById(this.modalAuditLogId), {backdrop:'static'})
			this.modalAuditLogs.show();
		},

		//vyber stranky v strankovaci
		onChangePage(selectedPage) {
			this.logSelectedPage=selectedPage
			this.onLoadPage();
		},

		//vyber poctu zaznamov
		onChangeRecords(selectedCount) {
			this.logSelectedPage=1;
			this.logSelectedRecords=selectedCount
			this.onLoadPage();
		},
		
		
		onClose:function(){
			this.modalObject.hide();
		},
		
		
		
	},
	
	watch: {
		docId() {
			if(this.docId){
				this.onLoadPage();
			}
			
		}
	},

	computed:{
		
	},
	
})

</script>

<template>
	<div>
		<LoadingScreen :isLoading="isLoading"></LoadingScreen>
		<div v-if="logTotalCount>0">
			<div class="row">
				<div class="col-12">
				
					<div class="table-responsive">
						<table class="table table-hover table-sm">
						
							<thead>
								<tr>
									<th>{{$t('msgCore.Created')}}</th>
								
									<th>{{$t('msgCore.CreatedBy')}}</th>

									<th>Typ</th>
									<th></th>
								</tr>
							</thead>
							
							
							<tr v-for="(basicObj) in logList" :key="basicObj" >
																		
								<td v-on:click="loadModalAuditLogDetail(basicObj.created,basicObj.document,basicObj.type)"><a href="#">{{ basicObj.createdView }}</a></td>
								
								<td>{{ basicObj.creator }}</td>
													
								

								<td>{{ basicObj.type }}</td>
								<td>{{ basicObj.id }}</td>
								
							</tr>
							
						</table>	
					</div>

					
					
				</div>
			</div>

			<div class="row row-pagination">
				<div class="col-6 col-md-3 col-lg-2">
					<MyCountRecords :selectedRecords="logSelectedRecords" @onSelectRecords="onChangeRecords"></MyCountRecords>
				</div>
				
				<div class="col-6 col-md-3 col-lg-2 box-flex">
					<span>Počet: {{logTotalCount}} </span>
				</div>
				
				<div class="col-12 col-md-6 col-lg-8">	
					<MyPagination :selectedRecords="logSelectedRecords" :totalCount="logTotalCount" :selectedPage="logSelectedPage" @onSelectPage="onChangePage"></MyPagination>
				</div>
			</div>

		</div>

		<div v-else class="row">
			<div class="col-12 mt-3">
				<Alert type="warning" :label="$t('msgCore.forThisSelectExistAnyData')" />
			</div>							
		</div>

		<AuditLog :auth="auth" :secData="secData" :currentDoc="currentDoc" :typeId="String(selectedTypeId)" :date="String(selectedDate)" :docId="String(selectedDocId)" :modalObject="modalAuditLogs" :modalId="modalAuditLogId"></AuditLog>

	</div>
		
</template>


